import { ReactElement } from 'react';

import { BLUE_01 } from 'utils/colors';

export const ChevronDown = ({ color = '#62656A', style = {} }): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={style}>
    <path d="M6.28125 9L11.7308 14L17.2813 9" stroke={color} strokeWidth="2" />
  </svg>
);

export const ChevronUp = ({ color = '#62656A', style = {} }): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={style}>
    <path d="M17.7188 15L12.2692 10L6.71875 15" stroke={color} strokeWidth="2" />
  </svg>
);

export const Chevron = ({ color = '#62656A', style = {} }): ReactElement => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={style} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.707 17.707L16.414 12L10.707 6.29297L9.29303 7.70697L13.586 12L9.29303 16.293L10.707 17.707Z"
      fill={color}
    />
  </svg>
);

export const InternetIcon = ({ color = '#A3A7AE', style = {} }): ReactElement => (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 7C16.4477 7 16 7.44772 16 8V11H6V8C6 7.44772 5.55228 7 5 7C4.44772 7 4 7.44772 4 8V11H1C0.447715 11 0 11.4477 0 12V20C0 20.5523 0.447716 21 1 21H21C21.5523 21 22 20.5523 22 20V12C22 11.4477 21.5523 11 21 11H18V8C18 7.44772 17.5523 7 17 7ZM2 19V13H20V19H2ZM8.75 15C8.33579 15 8 15.3358 8 15.75C8 16.1642 8.33579 16.5 8.75 16.5H13.25C13.6642 16.5 14 16.1642 14 15.75C14 15.3358 13.6642 15 13.25 15H8.75Z"
      fill={color}
    />
    <path
      d="M5 2.48318L6.09091 3.57409C8.80182 0.863182 13.1982 0.863182 15.9091 3.57409L17 2.48318C13.6891 -0.827727 8.31636 -0.827727 5 2.48318ZM9.36364 6.84682L11 8.48318L12.6364 6.84682C11.7364 5.94136 10.2691 5.94136 9.36364 6.84682ZM7.18182 4.665L8.27273 5.75591C9.77818 4.25045 12.2218 4.25045 13.7273 5.75591L14.8182 4.665C12.7127 2.55955 9.29273 2.55955 7.18182 4.665Z"
      fill={color}
    />
  </svg>
);

export const TVIcon = ({ color = '#A3A7AE', style = {} }): ReactElement => (
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path
      d="M20 4H12.42L15.71 0.71L15 0L11 4H10.97L6.97 0L6.28 0.71L9.56 4H2C0.9 4 0 4.9 0 6V18C0 19.1 0.9 20 2 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H2V6H20V18Z"
      fill={color}
    />
  </svg>
);

export const CallIcon = ({ color = '#A3A7AE', style = {} }): ReactElement => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path
      d="M3.54 2C3.6 2.89 3.75 3.76 3.99 4.59L2.79 5.79C2.38 4.59 2.12 3.32 2.03 2H3.54ZM13.4 14.02C14.25 14.26 15.12 14.41 16 14.47V15.96C14.68 15.87 13.41 15.61 12.2 15.21L13.4 14.02ZM4.5 0H1C0.45 0 0 0.45 0 1C0 10.39 7.61 18 17 18C17.55 18 18 17.55 18 17V13.51C18 12.96 17.55 12.51 17 12.51C15.76 12.51 14.55 12.31 13.43 11.94C13.33 11.9 13.22 11.89 13.12 11.89C12.86 11.89 12.61 11.99 12.41 12.18L10.21 14.38C7.38 12.93 5.06 10.62 3.62 7.79L5.82 5.59C6.1 5.31 6.18 4.92 6.07 4.57C5.7 3.45 5.5 2.25 5.5 1C5.5 0.45 5.05 0 4.5 0Z"
      fill={color}
    />
  </svg>
);

export const CheckIcon = ({ style = {} }): ReactElement => (
  <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M1 5.5L6 10.5L15.5 1" stroke="#A3A7AE" strokeWidth="2" />
  </svg>
);

export const RadioSelected = ({ style = {}, id = '' }): ReactElement => (
  <svg
    id={id}
    className="radio"
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6Z"
      fill={BLUE_01}
    />
  </svg>
);

export const RadioUnselected = ({ style = {}, id = '' }): ReactElement => (
  <svg
    id={id}
    className="radio"
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6Z"
      fill="#F3F4F8"
    />
  </svg>
);

export const FinishCheckIcon = ({ style = {} }): ReactElement => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <circle cx="24" cy="24" r="24" fill="#055CF5" />
    <path d="M15.9999 24.4029L21.7551 30.4782L33.1428 18.2856" stroke="white" strokeWidth="3" strokeLinecap="square" />
  </svg>
);

export const ExclamationMarkIcon = ({ style = {} }): ReactElement => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 18C13.95 18 18 13.95 18 9C18 4.05 13.95 -3.54062e-07 9 -7.86805e-07C4.05 -1.21955e-06 1.21955e-06 4.05 7.86805e-07 9C3.54062e-07 13.95 4.05 18 9 18Z"
      fill="#EFF7FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.8711 12.981C7.8711 12.348 8.3851 11.834 9.0181 11.834C9.6521 11.834 10.1651 12.348 10.1651 12.981C10.1651 13.614 9.6521 14.128 9.0181 14.128C8.3851 14.128 7.8711 13.614 7.8711 12.981Z"
      fill="#055CF5"
    />
    <path d="M9 10.25L9 4" stroke="#055CF5" strokeWidth="1.5" />
  </svg>
);

export const CashbackIcon = ({ style = {} }): ReactElement => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <rect width="16" height="16" rx="4" fill="#62656A" />
    <path
      d="M10.5299 4.51726C10.5299 3.95709 10.0728 3.5 9.51265 3.5C8.95249 3.5 8.49988 3.95709 8.49988 4.51726V5.53451H9.51714C10.0728 5.53003 10.5299 5.07742 10.5299 4.51726Z"
      fill="white"
    />
    <path
      d="M7.52991 5.53003V4.51726C7.52991 3.95709 7.0773 3.5 6.51714 3.5C5.95697 3.5 5.49988 3.95709 5.49988 4.51726C5.49988 5.07742 5.95697 5.53451 6.51714 5.53451L7.52991 5.53003Z"
      fill="white"
    />
    <path d="M3.99988 12.5H7.49988V12.4798V9.5H3.99988V12.5Z" fill="white" />
    <path d="M8.49988 12.4798V12.5H11.9999V9.5H8.49988V12.4798Z" fill="white" />
    <path d="M3.99988 8.5H7.49988V8.48654V6.5H3.99988V8.5Z" fill="white" />
    <path d="M8.49988 8.48654V8.5H11.9999V6.5H8.49988V8.48654Z" fill="white" />
  </svg>
);

export const PriceIcon = ({ style = {} }): ReactElement => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <rect width="16" height="16" rx="4" fill="#62656A" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.55556 4.61084H7.44444L7.44457 4.61127H7.44444L6.5517 7.94417H5.00385L4.11111 4.61127H3L3.95226 7.94417H3V9.05528H4.26972L5.22222 12.3891H6.33333L7.28584 9.05528H8.71429L9.66667 12.3886H10.7778L11.7302 9.05528H13V7.94417H12.0476L13 4.61084H11.8889L10.996 7.94417H9.44841L8.55556 4.61084ZM9.74603 9.05528L10.2222 10.8331L10.6984 9.05528H9.74603ZM8.39683 7.94417L8.00006 6.5555L7.6033 7.94417H8.39683ZM6.25408 9.05528H5.30147L5.77778 10.8335L6.25408 9.05528Z"
      fill="white"
    />
  </svg>
);

export const AlertIcon = ({ style = {} }): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" style={style}>
    <rect width="18" height="18" rx="9" fill="#ED5A4D" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.74999 10.25L9.74999 4H8.24999L8.24999 10.25H9.74999ZM9.01809 11.8341C8.38509 11.8341 7.87109 12.3481 7.87109 12.9811C7.87109 13.6141 8.38509 14.1281 9.01809 14.1281C9.65209 14.1281 10.1651 13.6141 10.1651 12.9811C10.1651 12.3481 9.65209 11.8341 9.01809 11.8341Z"
      fill="white"
    />
  </svg>
);

export const LaptopIcon = ({ color = '#A3A7AE', style = {} }): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={style}>
    <path
      d="M0 21V19.5H3.525V18.45H2.025V4H21.975V18.45H20.475V19.5H24V21H0ZM3.525 16.95H20.475V5.5H3.525V16.95Z"
      fill={color}
    />
  </svg>
);

export const GamingConsoleIcon = ({ color = '#A3A7AE', style = {} }): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" style={style}>
    <path
      d="M4.52281 20.7982C3.42816 20.7982 2.49316 20.4059 1.71779 19.6214C0.942417 18.8369 0.536488 17.8883 0.5 16.7754C0.5 16.6112 0.509122 16.447 0.527366 16.2828C0.54561 16.1186 0.572976 15.9544 0.609464 15.7902L2.90821 6.59521C3.16363 5.61003 3.68358 4.81186 4.46807 4.20068C5.25257 3.58951 6.14652 3.28392 7.14994 3.28392H17.8227C18.8261 3.28392 19.7201 3.58951 20.5046 4.20068C21.2891 4.81186 21.809 5.61003 22.0644 6.59521L24.3632 15.7902C24.3997 15.9544 24.4316 16.1231 24.459 16.2965C24.4863 16.4698 24.5 16.6385 24.5 16.8027C24.5 17.9156 24.1032 18.8597 23.3096 19.6351C22.516 20.4105 21.5627 20.7982 20.4498 20.7982C19.6836 20.7982 18.9721 20.5975 18.3153 20.1961C17.6585 19.7948 17.1659 19.2474 16.8375 18.5542L16.0713 16.9669C15.98 16.7845 15.8432 16.6477 15.6608 16.5564C15.4783 16.4652 15.2868 16.4196 15.0861 16.4196H9.88655C9.68586 16.4196 9.4943 16.4652 9.31186 16.5564C9.12942 16.6477 8.99259 16.7845 8.90137 16.9669L8.13512 18.5542C7.80673 19.2474 7.31414 19.7948 6.65736 20.1961C6.00057 20.5975 5.28905 20.7982 4.52281 20.7982ZM4.59568 19.1562C5.03969 19.1562 5.45021 19.0379 5.82726 18.8012C6.20429 18.5645 6.49011 18.245 6.68472 17.8426L7.45097 16.2828C7.68814 15.8084 8.0211 15.439 8.44983 15.1745C8.87856 14.9099 9.35747 14.7776 9.88655 14.7776H15.0861C15.6152 14.7776 16.0941 14.9145 16.5228 15.1881C16.9515 15.4618 17.2936 15.8267 17.549 16.2828L18.3153 17.8426C18.5099 18.245 18.7957 18.5645 19.1727 18.8012C19.5498 19.0379 19.9596 19.1562 20.4021 19.1562C21.0542 19.1562 21.6174 18.9327 22.0918 18.4857C22.5661 18.0388 22.8124 17.4869 22.8307 16.8301C22.8307 16.7571 22.8033 16.5382 22.7486 16.1733L20.4498 7.0057C20.3039 6.40365 19.9901 5.9065 19.5084 5.51425C19.0268 5.122 18.4649 4.92588 17.8227 4.92588H7.14994C6.5168 4.92588 5.95715 5.11744 5.47098 5.50057C4.98482 5.88369 4.66876 6.3854 4.52281 7.0057L2.22406 16.1733C2.20582 16.2463 2.17845 16.4561 2.14196 16.8027C2.14196 17.4684 2.38149 18.027 2.86054 18.4787C3.33961 18.9304 3.91799 19.1562 4.59568 19.1562ZM14.1331 10.6727C14.367 10.6727 14.5616 10.5936 14.7166 10.4353C14.8717 10.2771 14.9493 10.0809 14.9493 9.84698C14.9493 9.613 14.8701 9.41847 14.7119 9.2634C14.5536 9.10832 14.3575 9.03078 14.1235 9.03078C13.8895 9.03078 13.695 9.10992 13.5399 9.26818C13.3848 9.42647 13.3073 9.62259 13.3073 9.85655C13.3073 10.0905 13.3864 10.2851 13.5447 10.4401C13.703 10.5952 13.8991 10.6727 14.1331 10.6727ZM16.3224 8.48346C16.5563 8.48346 16.7509 8.40433 16.9059 8.24606C17.061 8.08778 17.1385 7.89166 17.1385 7.65769C17.1385 7.42372 17.0594 7.22919 16.9011 7.07411C16.7429 6.91904 16.5467 6.8415 16.3128 6.8415C16.0788 6.8415 15.8843 6.92064 15.7292 7.0789C15.5741 7.23719 15.4966 7.43331 15.4966 7.66727C15.4966 7.90125 15.5757 8.09578 15.734 8.25085C15.8923 8.40593 16.0884 8.48346 16.3224 8.48346ZM16.3224 12.862C16.5563 12.862 16.7509 12.7829 16.9059 12.6246C17.061 12.4663 17.1385 12.2702 17.1385 12.0363C17.1385 11.8023 17.0594 11.6078 16.9011 11.4527C16.7429 11.2976 16.5467 11.2201 16.3128 11.2201C16.0788 11.2201 15.8843 11.2992 15.7292 11.4575C15.5741 11.6158 15.4966 11.8119 15.4966 12.0458C15.4966 12.2798 15.5757 12.4743 15.734 12.6294C15.8923 12.7845 16.0884 12.862 16.3224 12.862ZM18.5116 10.6727C18.7456 10.6727 18.9401 10.5936 19.0952 10.4353C19.2503 10.2771 19.3278 10.0809 19.3278 9.84698C19.3278 9.613 19.2487 9.41847 19.0904 9.2634C18.9321 9.10832 18.736 9.03078 18.5021 9.03078C18.2681 9.03078 18.0735 9.10992 17.9185 9.26818C17.7634 9.42647 17.6859 9.62259 17.6859 9.85655C17.6859 10.0905 17.765 10.2851 17.9233 10.4401C18.0815 10.5952 18.2777 10.6727 18.5116 10.6727ZM8.65825 12.4515C8.85682 12.4515 9.01996 12.3869 9.14766 12.2577C9.27537 12.1285 9.33923 11.965 9.33923 11.7674V10.5359H10.5707C10.7683 10.5359 10.9318 10.471 11.061 10.3412C11.1902 10.2113 11.2548 10.0471 11.2548 9.84859C11.2548 9.65002 11.1902 9.48689 11.061 9.35918C10.9318 9.23147 10.7683 9.16761 10.5707 9.16761H9.33923V7.93614C9.33923 7.73851 9.27431 7.57507 9.14449 7.44583C9.01465 7.3166 8.85045 7.25199 8.6519 7.25199C8.45333 7.25199 8.29019 7.3166 8.16249 7.44583C8.03478 7.57507 7.97092 7.73851 7.97092 7.93614V9.16761H6.73945C6.54182 9.16761 6.37838 9.23253 6.24914 9.36235C6.11991 9.4922 6.0553 9.65639 6.0553 9.85494C6.0553 10.0535 6.11991 10.2166 6.24914 10.3444C6.37838 10.4721 6.54182 10.5359 6.73945 10.5359H7.97092V11.7674C7.97092 11.965 8.03584 12.1285 8.16566 12.2577C8.2955 12.3869 8.4597 12.4515 8.65825 12.4515Z"
      fill={color}
    />
  </svg>
);

export const MicIcon = ({ color = '#A3A7AE', style = {} }): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style={style}>
    <path
      d="M11.9998 14.4316C11.0946 14.4316 10.3367 14.1061 9.72614 13.4553C9.11561 12.8044 8.81035 12.014 8.81035 11.0842V3.15789C8.81035 2.28069 9.12025 1.53508 9.74006 0.921063C10.3599 0.307021 11.1125 0 11.998 0C12.8834 0 13.6367 0.307021 14.2577 0.921063C14.8788 1.53508 15.1893 2.28069 15.1893 3.15789V11.0842C15.1893 12.014 14.884 12.8044 14.2735 13.4553C13.663 14.1061 12.9051 14.4316 11.9998 14.4316ZM11.0525 24V19.7053C8.82087 19.4737 6.94719 18.5368 5.4314 16.8947C3.91561 15.2526 3.15771 13.3158 3.15771 11.0842H5.05245C5.05245 13 5.72917 14.6105 7.0826 15.9158C8.43603 17.2211 10.0729 17.8737 11.9931 17.8737C13.9134 17.8737 15.5525 17.2211 16.9103 15.9158C18.2682 14.6105 18.9472 13 18.9472 11.0842H20.8419C20.8419 13.3158 20.084 15.2526 18.5682 16.8947C17.0525 18.5368 15.1788 19.4737 12.9472 19.7053V24H11.0525ZM11.9998 12.5368C12.3788 12.5368 12.6893 12.3947 12.9314 12.1105C13.1735 11.8263 13.2946 11.4842 13.2946 11.0842V3.15789C13.2946 2.8 13.1705 2.5 12.9223 2.25789C12.6742 2.01579 12.3667 1.89474 11.9998 1.89474C11.633 1.89474 11.3255 2.01579 11.0773 2.25789C10.8292 2.5 10.7051 2.8 10.7051 3.15789V11.0842C10.7051 11.4842 10.8261 11.8263 11.0682 12.1105C11.3103 12.3947 11.6209 12.5368 11.9998 12.5368Z"
      fill={color}
    />
  </svg>
);

export const ArrowWithoutTailIcon = ({ style = {} }): ReactElement => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M7.55469 5.5L12.5547 10.5L7.55469 15.5" stroke="#A3A7AE" strokeWidth="1.5" strokeLinecap="square" />
  </svg>
);

export const ArrowIcon = ({ style = {} }): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none" style={style}>
    <path
      d="M20 5.55556H4.25556L8.23333 1.56667L6.66667 0L0 6.66667L6.66667 13.3333L8.23333 11.7667L4.25556 7.77778H20V5.55556Z"
      fill="#080808"
    />
  </svg>
);

export const ArrowWithTailIcon = ({ style = {} }): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" style={style}>
    <g clip-path="url(#clip0_5855_51766)">
      <path
        d="M4.1665 9.75H3.4165V11.25H4.1665V9.75ZM15.8332 11.25C16.2474 11.25 16.5832 10.9142 16.5832 10.5C16.5832 10.0858 16.2474 9.75 15.8332 9.75V11.25ZM4.1665 11.25H15.8332V9.75H4.1665V11.25Z"
        fill="#055CF5"
      />
      <path
        d="M10.8335 15.5L15.8335 10.5"
        stroke="#055CF5"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M10.8335 5.5L15.8335 10.5"
        stroke="#055CF5"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5855_51766">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
